import React from "react";

function TermsAndConditions() {
  return (
    <div className="terms-page" style={{marginTop: '150px'}}>
      <div className="terms-container">
        <h1>Términos y Condiciones de Uso</h1>
        <p><strong>Fecha de entrada en vigencia: 28-09-2024</strong></p>
        <p>
          Por favor, lee atentamente estos términos y condiciones antes de
          utilizar el sitio web de <strong>MoneyMoverOficial</strong>, operado por la empresa.
          Al registrarte y utilizar nuestros servicios, aceptas cumplir con los
          siguientes términos y condiciones. Si no estás de acuerdo con estos
          términos, te rogamos que no utilices nuestro sitio web ni nuestros
          servicios.
        </p>

        <h2>1. Registro</h2>
        <p>
          Para utilizar nuestros servicios, debes registrarte en nuestra
          plataforma <a href="https://moneymoveroficial.com">https://moneymoveroficial.com</a>, proporcionando tu nombre,
          apellido, número de teléfono, correo electrónico, dirección y
          establecer una contraseña personal. Asegúrate de mantener tu
          información de registro actualizada en todo momento.
        </p>
        <p>
          Una vez registrado, procedemos a realizar un KYC (Know Your Customer)
          con una herramienta que nos permite comprobar los datos de nuestros
          clientes, protegiéndolos de que su identidad no sea usurpada. Esta
          validación se realiza mediante un documento de identidad vigente y
          video identificación facial.
        </p>
        <p>
          Una vez validada la información proporcionada, se activará tu usuario
          para que puedas disfrutar de todos los servicios que ofrece
          <strong>MoneyMoverOficial</strong>.
        </p>
        <p>
          En caso de incongruencias en la información proporcionada, se podrá
          solicitar documentación adicional e incluso bloquear el perfil del
          Usuario.
        </p>
        <p>
          Eres responsable de mantener la confidencialidad de tu información de
          inicio de sesión y de todas las actividades que ocurran bajo tu
          cuenta. Si sospechas que tu cuenta ha sido comprometida, notifícanos
          de inmediato.
        </p>

        <h2>2. Cuenta de Usuario</h2>
        <p>
          Una vez registrado, el Usuario tendrá acceso a su cuenta, la cual
          permite almacenar todas las operaciones por fecha, moneda y nombre del
          beneficiario. Podrás guardar los datos de las cuentas bancarias en
          directorios para facilitar las operaciones, brindando mayor rapidez al
          enviar dinero.
        </p>
        <p>
          A través de la cuenta, el Usuario podrá consultar los detalles de las
          operaciones realizadas, el estado de sus envíos, y recibirá
          notificaciones por email cuando se haya realizado el envío, así como
          comunicaciones sobre la operativa o posibles incidencias.
        </p>

        <h2>3. Servicios de Cambio de Divisas</h2>
        <p>
          <a href="https://moneymoveroficial.com">https://moneymoveroficial.com</a> proporciona servicios de cambio de divisas en
          euros. Los tipos de cambio y las tarifas aplicables se mostrarán en
          nuestro sitio web y podrán estar sujetos a cambios sin previo aviso.
        </p>
        <p>
          Al utilizar nuestros servicios, aceptas los tipos de cambio y las
          tarifas aplicables en el momento de la transacción.
        </p>
        <p>
          Te comprometes a proporcionar información precisa y veraz relacionada
          con las transacciones de cambio de divisas que realices a través de
          nuestro sitio web.
        </p>

        <h2>4. Uso Adecuado</h2>
        <p>
          Aceptas utilizar nuestro sitio web <a href="https://moneymoveroficial.com">https://moneymoveroficial.com</a> y
          servicios de manera legal y ética. No debes utilizar nuestros
          servicios para actividades ilegales o fraudulentas.
        </p>
        <p>
          No está permitido utilizar nuestro sitio web para distribuir contenido
          dañino, difamatorio, obsceno o cualquier otro material inapropiado.
        </p>

        <h2>5. Responsabilidad y Exoneración de Responsabilidad</h2>
        <p>
          <strong>MoneyMoverOficial</strong> no se hace responsable de los daños, pérdidas o perjuicios
          que puedan surgir como resultado del uso de nuestros servicios o de la
          información proporcionada en nuestro sitio web <a href="https://moneymoveroficial.com">https://moneymoveroficial.com</a>.
        </p>
        <p>
          No garantizamos la disponibilidad continua y sin interrupciones de
          nuestros servicios y nos reservamos el derecho de suspenderlos o
          interrumpirlos en cualquier momento sin previo aviso.
        </p>

        <h2>6. Privacidad</h2>
        <p>
          La recopilación y el uso de tus datos personales están sujetos a
          nuestra Política de Privacidad, que puedes consultar en nuestro sitio
          web <a href="https://moneymoveroficial.com/privacy">https://moneymoveroficial.com/privacy</a>. Es de suma importancia leerla detenidamente. 
          Si no estás de acuerdo, por favor no aceptes estos términos y condiciones, ya que no podremos prestarte el servicio.
        </p>

        <h2>7. Modificaciones de los Términos y Condiciones</h2>
        <p>
          Nos reservamos el derecho de modificar estos términos y condiciones en
          cualquier momento. Las modificaciones entrarán en vigencia
          inmediatamente después de su publicación en nuestro sitio web <a href="https://moneymoveroficial.com">https://moneymoveroficial.com</a>.
        </p>

        <h2>8. Ley Aplicable</h2>
        <p>
          Estos términos y condiciones se rigen por las leyes de la Unión
          Europea y España. Cualquier disputa que surja en relación con estos
          términos estará sujeta a la jurisdicción exclusiva de los tribunales
          competentes en España.
        </p>

        <h2>9. Prevención del Blanqueo de Capitales y Financiación del Terrorismo</h2>
        <p>
          Cuando el Usuario se registre en la Plataforma <a href="https://moneymoveroficial.com">https://moneymoveroficial.com</a> y
          posteriormente realice una operación, se solicitarán los documentos
          necesarios para la gestión del servicio de envío de dinero y la
          información y documentación personal de los usuarios que sea necesaria
          para la correcta identificación. Esto incluye medidas de diligencia
          debida, como la identificación formal, titularidad real, dirección,
          ocupación y origen de los fondos.
        </p>
        <p>
          Si se tuviera conocimiento de algún hecho u operación susceptible de
          estar relacionada con el blanqueo de capitales o con la financiación
          del terrorismo, se informará a las autoridades competentes.
        </p>
        <p>
          <strong>MoneyMoverOficial</strong> conservará la documentación de los clientes en nombre de las
          autoridades competentes durante los plazos estipulados por la
          normativa de prevención del blanqueo de capitales y de la financiación
          del terrorismo.
        </p>

        <p>Gracias por elegir <strong>MoneyMoverOficial</strong>. Si tienes alguna pregunta o inquietud, por favor
          contáctanos a través de <a href="mailto:info@moneymoveroficial.com">info@moneymoveroficial.com</a>.
        </p>
      </div>
    </div>
  );
}

export  {TermsAndConditions};
